<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">
        Registra Articoli Residui
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Finto bottone del reader, che esegue la validazione e
           se serve innesca il metodo dentro il vero reader. -->
      <!--<v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            bottom
            @click="handleDataMatrixClick"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-qrcode</v-icon>
          </v-btn>
        </template>
        <span>Scansiona il QR CODE</span>
      </v-tooltip>-->

      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers_art_res"
              :items="items_art_res"
              height="40vh"
            >
              <template v-slot:[`item.stampa`]="{ item }">
                <!-- Bottone del salvataggio per la generazione dei PDF -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      @click="salvaArticoliResidui(item)"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary"> mdi-printer </v-icon>
                    </v-btn>
                  </template>
                  <span>Stampa</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.dimensioni`]="{ item }">
                <v-textarea
                  background-color="white"
                  dense
                  hide-details
                  outlined
                  rows="2"
                  style="border-radius: 0px"
                  v-model="item.dimensioni"
                ></v-textarea>
              </template>
              <template v-slot:[`item.quantita`]="{ item }">
                <v-text-field
                  background-color="white"
                  dense
                  hide-details
                  outlined
                  style="border-radius: 0px; max-width: 150px"
                  type="number"
                  v-model.number="item.quantita"
                ></v-text-field>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Dialog di conferma registrazione -->
    <v-dialog v-model="dialog_conferma_registrazione" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Conferma </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="confermaSalvataggio()"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiDialogConferma"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <span style="color: black; font-size: 17px; font-size: 25px">
            Confermi la registrazione?
          </span>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="pdfdialog" width="70vw" height="300px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Stampa Etichetta
          </v-toolbar-title>
          <!--<v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="mr-5"
                @click="stampaEtichetta"
                small
              >
                <v-icon color="success"> mdi-printer-check </v-icon>
              </v-btn>
            </template>
            <span>invia stampa </span>
          </v-tooltip>-->
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="mr-5"
                @click="pdfdialog = false"
                small
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="pt-5" style="text-align: center">
          <!--<vue-pdf-embed
          class="elevation-5"
            :source="this.selected_pdf"
            :width="'500'"
            :height="'500'"
            style="display:inline-block;"
          ></vue-pdf-embed>-->
          <iframe
            :src="this.selected_pdf + '#page=1&zoom=300'"
            frameborder="0"
            style="display: inline-block; height: 80vh !important; width: 80%"
          ></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- Overlay -->
    <v-overlay :value="overlay" style="z-index: 999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>
<script>
import moment from "moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
//import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";

class Qrcode {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }
  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }
  setCampi() {
    const campi = [
      { nome: "check_seriale", default_val: null },
      { nome: "cod_articolo", default_val: null },
      { nome: "des_articolo", default_val: "" },
      { nome: "id_articolo", default_val: "" },
      { nome: "id_magazzino", default_val: "" },
      { nome: "id_um", default_val: null },
      { nome: "quantita", default_val: null },
      { nome: "numero_seriale", default_val: -1 },
    ];
    return campi;
  }
}

export default {
  name: "RegistraArtRes",
  components: { SnackbarQV /*, VuePdfEmbed*/ },
  props: {
    work_order_sel: { type: Object, default: null },
  },
  data() {
    return {
      // Variabili d'appoggio
      qr_code_sel: new Qrcode(),
      selected_pdf: "",

      // Modal
      dialog_conferma_registrazione: false,
      overlay: false,
      pdfdialog: false,

      // Array
      items_art_res: new Array(),
      headers_art_res: [
        { text: "Stampa", value: "stampa", sortable: false },
        { text: "Cod. Articolo Alt.", value: "cod_articolo", sortable: false },
        { text: "Des. Articolo Alt.", value: "des_articolo", sortable: false },
        { text: "Note", value: "note", sortable: false },
        {
          text: "Dimensioni",
          value: "dimensioni",
          sortable: false,
          width: "350px",
        },
        {
          text: "Quantità",
          value: "quantita",
          width: "150px",
          sortable: false,
        },
      ],
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    chiudiDialogConferma() {
      this.dialog_conferma_registrazione = false;
      this.qr_code_sel = new Qrcode();
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    confermaSalvataggio() {
      const REQUEST = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "registraarticoliresidui",
          token: localStorage.user_token,
          articoli: [
            {
              id_magazzino: this.items_art_res.filter(
                (elem) => elem.cod_articolo == this.qr_code_sel.cod_articolo
              )[0].id_magazzino_predefinito,
              numero_seriale: this.qr_code_sel.numero_seriale,
            },
          ],
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", REQUEST)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            // Chiudo la finestra di dialogo di conferma
            this.dialog_conferma_registrazione = false;

            // Stampo una snackbar di conferma.
            this.$refs.SnackbarQV.print("success", "Registrazione effettuata.");
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, impossibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile salvare i dati."
          );
        });
    },
    formatData(arg) {
      if (arg == null || arg == "") {
        return "N/D";
      } else {
        let strRes = "";
        strRes += arg.substr(8, 2);
        strRes += "/";
        strRes += arg.substr(5, 2);
        strRes += "/";
        strRes += arg.substr(0, 4);
        return strRes;
      }
    },
    getArticoloRes() {
      this.overlay = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessafull",
          token: localStorage.getItem("user_token"),
          id_commessa: this.work_order_sel.id_commessa,
          id_profilo: localStorage.id_profilo,
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            /* Faccio cosmesi sugli oggetti per comodità di FE
             * e per preparare la chiamata di salvataggio. */
            res.data.commessa_distinta.forEach((elem) => {
              elem.cod_articolo = elem.name.split("PZ x ")[1].split(" : ")[0];
              elem.des_articolo = elem.name.split("PZ x ")[1].split(" : ")[1];
              delete elem.name;
              elem.quantita = 0;
              elem.dimensioni = "";
              if (elem.children) {
                delete elem.children;
              }
              elem.id_articolo = elem.id_componente;
              delete elem.id_componente;
            });

            // Finita la cosmesi, registro gli oggetti.
            this.items_art_res = res.data.commessa_distinta;
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    handleDataMatrixClick() {
      // Se i controlli sono ok, attivo la telecamera.
      this.$refs.qr.attiva_telecamera();
    },
    salvaArticoliResidui(arg) {
      /* Devo generare il PDF dell'etichetta dell'articolo
       * che è passato in argomento alla funzione. */

      // Controllo che la quantità sia positiva.
      if (arg.quantita == null || arg.quantita === "" || arg.quantita <= 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Dichiarare una quantità maggiore di 0 per registrare."
        );

        return;
      }

      const art_res_request = {
        id_magazzino_movimenti: -1,
        data: moment().format("YYYY-MM-DD HH:mm:ss"),
        id_articolo: arg.id_articolo,
        cod_articolo: arg.cod_articolo,
        des_articolo: arg.des_articolo,
        id_commessa: this.work_order_sel.id_commessa,
        id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
        id_causale: "",
        id_magazzino: -99,
        id_causale_magazzino: 1,
        quantita: arg.quantita,
        id_um: arg.id_um,
        flag_export: 0,
        stato_controllo: 0,
        numero_seriale: -1,
        validita: 1,
        note:
          arg.note != null && arg.note != ""
            ? arg.note + " - " + arg.dimensioni
            : arg.dimensioni,
      };

      /* Mando al BE la request. Il seriale con tipo REGISTRAZIONE_ARTICOLO_RESIDUO
       * viene incrementato quando viene generato il PDF nel contesto di questa chiamata.
       * La chiamata genera anche un serialem, ma lo genera a BE e non devo passarlo in
       * questa sede: fa tutto la logica C# sul server. */
      const arr_tmp = [
        {
          parametro: "@id_articolo_residuo",
          valore: arg.id_articolo,
        },
        {
          parametro: "@nominativo_persona",
          valore: localStorage.nominativo,
        },
        {
          parametro: "@quantita",
          valore: arg.quantita,
        },
        {
          parametro: "@id_commessa_distinta_base",
          valore: arg.id_commessa_distinta_base,
        },
      ];

      if (this.work_order_sel.cod_commessa) {
        arr_tmp.push({
          parametro: "@cod_commessa",
          valore: this.work_order_sel.cod_commessa,
        });
      }

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "registraestampaartres",
          token: localStorage.user_token,
          quantita_etichette: 1,
          articolo: [art_res_request],
          dati_report: {
            cod_report: "ReportArtRes",
            parametri: arr_tmp,
          },
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then(async (res) => {
          this.overlay = false;

          if (res.status === 200) {
            if (
              "tipo_messaggio" in res.data &&
              "query_messaggio" in res.data &&
              res.data.tipo_messaggio == 1
            ) {
              this.$refs.SnackbarQV.print("orange", res.data.query_messaggio);
            }

            const byteCharacters = atob(res.data.result);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });
            const blobUrl = URL.createObjectURL(blob);
            this.selected_pdf = blobUrl;
            this.pdfdialog = true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Invio di stampa non riuscito"
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          if (
            "tipo_messaggio" in err.response.data &&
            "query_messaggio" in err.response.data &&
            err.response.data.tipo_messaggio == 2
          ) {
            this.$refs.SnackbarQV.print(
              "error",
              err.response.data.query_messaggio
            );
          } else {
            if (err) {
              this.$refs.SnackbarQV.print(
                "error",
                "Invio di stampa non riuscito"
              );
            }
          }
        });
    },
  },
  created() {},
  mounted() {
    this.getArticoloRes();
  },
};
</script>
<style scoped>
</style>